import {
  GETCURRENCYMASTERLIST_SUCCESS,
  GETCURRENCYMASTERLIST_FAILED,
  RESET_GETCURRENCYMASTERLIST,
  LOADING_GETCURRENCYMASTERLIST,
  NETWORK_ERROR_GETCURRENCYMASTERLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetCurrencyMasterList = () => {
  return { type: RESET_GETCURRENCYMASTERLIST };
};

const getCurrencyMasterList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETCURRENCYMASTERLIST });
  await partnerServices
    .post("getCurrencyMasterList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getCurrencyMasterListSuccess(res.data));
          break;
        default:
          dispatch(getCurrencyMasterListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETCURRENCYMASTERLIST,
        payload: err,
      });
    });
};
function getCurrencyMasterListSuccess(data) {
  return {
    type: GETCURRENCYMASTERLIST_SUCCESS,
    payload: data,
  };
}
function getCurrencyMasterListFailed(data) {
  return {
    type: GETCURRENCYMASTERLIST_FAILED,
    payload: data,
  };
}

export { resetGetCurrencyMasterList, getCurrencyMasterList };
